export const getSupportedMimeType = (
  preferredTypes: string[] = [
    "video/mp4;codecs=avc1,mp4a.40.2",
    "video/mp4;codecs=avc1",
    "video/mp4",
    "video/webm;codecs=vp9,opus",
    "video/webm;codecs=vp8,opus",
    "video/webm",
  ]
) => {
  for (const type of preferredTypes) {
    if (MediaRecorder.isTypeSupported(type)) return type;
  }
  return "";
};
